import * as React from "react";
import { RouterProvider } from "react-router-dom";
import ThemeProvider from "@/themes";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, useTheme } from "@mui/material";
import { ToastContainer } from "material-react-toastify";
import rootRoutes from "@/router";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// Import for LocalizationProvider and the date adapter (using date-fns here)
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale"; // Import the locale from date-fns
import { SnackbarProvider } from "./components/toastifyNew/SnackbarContext";

function App() {
  const theme = useTheme();

  return (
    <ThemeProvider>
      <DndProvider backend={HTML5Backend}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <ToastContainer style={{ top: 45 }} />
          {/* <SnackbarProvider> */}
          <RouterProvider router={rootRoutes} />
          {/* </SnackbarProvider> */}
        </LocalizationProvider>
      </DndProvider>
    </ThemeProvider>
  );
}

export default App;
